import axios from "axios";

export const sendChatToGroq = async (userMessage) => {
  if (!userMessage || userMessage.trim() === "") {
    throw new Error("Message cannot be empty");
  }

  try {
    // Call the deployed backend
    const response = await axios.post(
      "https://fancity-backend-gwea1dutn-komal-anums-projects.vercel.app/api/chat",
      {
        message: userMessage,
      }
    );

    return response.data.reply; // make sure your backend returns { reply: "..." }
  } catch (error) {
    console.error("Chat Service Error:", error.message);
    throw new Error("Failed to connect to AI.");
  }
};
